import { TableDownloadButton } from "../sharedComponents.index";
import { ButtonDisplayStrategy } from "../../../viewModel/strategy/buttons/buttons.strategy";
import PropTypes from "prop-types";

export const OrderDetailsActions = ({ actions, ctx, uiState }) => {

  const { 
    setShowCancelModal, 
    setShowInputs, 
    onInputsSave, 
    createOrder,
    handleEdit,
  } = actions;
  
  const { 
    orderId, 
    tableInfo,
    suppliersAndProductRelations = [],
    hideOnExport = [],
    currentSupplierName = "",
    orderDate = "",
    storeName = ""
  } = ctx;

  const {
    showInputs, 
    customDisabledCondition, 
    isStoresTable,
    showDownloadButtonForXLS,
    saveLoading,
    buttonsDisplayMode,
    cameraIcon, 
    pdfIcon, 
    xlsIcon,
  } = uiState || {};

  const xlsFilename = buttonsDisplayMode === 'order_details_modal'
    ? `Loja-${storeName}-Data-${orderDate}-Fornecedor-${currentSupplierName}-Pedido-${orderId}`
    : "pedido"

  return (
    <div style={{ display: "flex", flexDirection: 'row', alignItems: "center", gap: "1rem" }}>
      <ButtonDisplayStrategy 
        mode={buttonsDisplayMode}
        actions={{
          setShowInputs: setShowInputs,
          setShowCancelModal: setShowCancelModal,
          onInputsSave: onInputsSave,
          handleEdit: handleEdit,
          createOrder: createOrder
        }}
        ctx={{
          suppliersAndProductRelations: suppliersAndProductRelations,
          orderId: orderId,
          storeName: storeName,
          orderDate: orderDate,
          currentSupplierName: currentSupplierName
        }}
        uiState={{
          showInputs: showInputs,
          saveLoading: saveLoading,
          customDisabledCondition: customDisabledCondition,
          pdfIcon: pdfIcon,
          cameraIcon: cameraIcon,
        }}        
      />        

      {showDownloadButtonForXLS && (
        <TableDownloadButton
          ctx={{
            fileName: xlsFilename,
            tableInfo: tableInfo,
            tableId: `download-table-${orderId}`,
            hideOnExport: hideOnExport
          }}
          uiState={{
            isStoresTable: isStoresTable,
            buttonType: "ghost",
            icon: xlsIcon
          }}/>
      )}
    </div>
  );
};

OrderDetailsActions.propTypes = {
  actions: PropTypes.object,
  uiState: PropTypes.object,
  ctx: PropTypes.object,
}